console.log("slick-carousel-offerte.js");
import $ from 'jquery';

class carouselSliderOfferte {

  constructor() {
    this.offerta = $(".vetrina-attivita .elementor-posts-container");
    this.initCarousel();
  }

  initCarousel() {
    this.offerta.slick({
      autoplay: false,
      autoplaySpeed: 4000,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
	  focusOnSelect: true,
	  variableWidth: true,
	  fade: false, 
      mobileFirst: true,
      arrows: true,
/*
      prevArrow: '<i class="flaticon-left-chevron slick-prev"></i>',
      nextArrow: '<i class="flaticon-right-chevron slick-next"></i>',
*/
      prevArrow: '<span class="slick-prev"></span>',
      nextArrow: '<span class="slick-next"></span>',


      responsive: [
        {
          breakpoint: 600,
          settings: {
          }
        },
        {
          breakpoint: 991,
          settings: {
          }
        }
      ]

    });
  }
}

export default carouselSliderOfferte;